import * as ResultsIntellectualProperty from './resultsIntellectualProperty.js';
export default ResultsIntellectualProperty;
